import React from 'react';
import TranslateIgnoreText from '@this/components/shared/text/translate_ignore_text';
import {
  type OrderItemDescriptionWhenRequestFormProps,
  SectionDescText,
  OutlineBox,
  SectionApplication,
  SectionApplicationInfo,
  SectionLabel,
  SectionDesc
} from './shared';

// リクエストフォームを利用した申請の場合は金額変動による表現は行わないようにする。
const OrderItemDescriptionWhenRequestForm: React.FC<OrderItemDescriptionWhenRequestFormProps> = ({ trip }) => {
  return trip.order ? (
    <>
      {trip.order.orderItems.map(orderItem => (
        <SectionDesc key={orderItem.id}>
          <p>
            <span>{`■${orderItem.orderItemCategoryText}：`}</span>
            {trip.arrangementRequest ? (
              <SectionDescText isOld={false}>
                <span data-wovn-ignore>{utils.digits(orderItem.price.price)}</span>
                <span>円</span>
              </SectionDescText>
            ) : (
              <>
                <SectionDescText isOld={orderItem.soldOut || orderItem.isPriceChanged}>
                  {utils.formatPrice(orderItem.firstPrice?.price || 0)}
                </SectionDescText>
                {orderItem.soldOut ? (
                  <SectionDescText isOld={false} className="red">
                    売り切れ
                  </SectionDescText>
                ) : orderItem.isPriceChanged ? (
                  <SectionDescText isOld={false} className="red">
                    {utils.formatPrice(orderItem.price.price)}
                  </SectionDescText>
                ) : null}
              </>
            )}
          </p>
          {orderItem.price.margin && orderItem.price.margin.amount !== 0 && (
            <p>{`■手数料：${utils.formatPrice(orderItem.price.margin.amount)}`}</p>
          )}
          {orderItem.elements.map(el => (
            <OutlineBox key={el.id}>
              <SectionApplication>
                <SectionLabel>
                  <p data-wovn-ignore>{`【${el.title}】`}</p>
                </SectionLabel>

                <SectionApplicationInfo>
                  {el.name && <p>{el.name}</p>}
                  <TranslateIgnoreText text={el.summary} />
                  <TranslateIgnoreText text={el.detail(orderItem)} />
                </SectionApplicationInfo>
              </SectionApplication>
            </OutlineBox>
          ))}
        </SectionDesc>
      ))}
    </>
  ) : null;
};

export default OrderItemDescriptionWhenRequestForm;
